__turbopack_context__.v({
  "button": "StQxca_button",
  "extraTagsCount": "StQxca_extraTagsCount",
  "tagsContainer": "StQxca_tagsContainer",
  "wrapper": "StQxca_wrapper",
});
